<h1 class="modal-header-custom">{{local_data.title}}</h1>
<div mat-dialog-content class="alert-container mt-3">
  @if (action != 'Delete') {
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>{{local_data.labelText1}}</mat-label>
      <input placeholder={{local_data.labelText1}} #name matInput [(ngModel)]="local_data.displayname">
    </mat-form-field>
  } @else {
    {{local_data.labelText1}} <b>{{local_data.displayname}}</b>?
  }

  <!-- <mat-form-field *ngIf="action != 'Delete'; else elseTemplate"> -->
  @if (action != 'Delete') {
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>{{local_data.labelText2}}</mat-label>
      <textarea placeholder={{local_data.labelText2}} #description matInput [(ngModel)]="local_data.description"></textarea>
    </mat-form-field>
  }

</div>
<div class="modal-bottom-btn">
  <button mat-button class="primary-btn-blue cancel-btn" (click)="closeDialog()" mat-flat-button color="warn">Cancel</button>
  <button mat-button class="primary-btn-blue" (click)="doAction()">{{local_data.buttonText}}</button>
</div>